import { useState, useEffect } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import api from '../../utils/api';
import styles from './Transaction.module.css';

function TransactionProfile() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const [bird, setBird] = useState(null);
    const [loading, setLoading] = useState(true);
    const [type, setType] = useState(searchParams.get('type') || 'sale'); // 'sale' ou 'purchase'
    const [errorMessage, setErrorMessage] = useState('');

    const [formData, setFormData] = useState({
        price: '',
        date: '',
        notes: ''
    });

    useEffect(() => {
        fetchBird();
    }, [id]);

    async function fetchBird() {
        setLoading(true);
        try {
            const token = JSON.parse(localStorage.getItem('token'));
            const response = await api.get(`/transaction/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });

            const currentBird = response.data.bird;
            setBird(currentBird);

            // Preenche formulário caso já existam dados gravados do tipo atual
            const activeDetails = type === 'sale' ? currentBird.sale_details : currentBird.purchase_details;
            if (activeDetails) {
                setFormData({
                    price: activeDetails.price || '',
                    date: activeDetails.date ? new Date(activeDetails.date).toISOString().split('T')[0] : '',
                    notes: activeDetails.notes || ''
                });
            }
        } catch (error) {
            console.error('Erro ao buscar ave:', error);
        } finally {
            setLoading(false);
        }
    }

    // Atualiza os dados do formulário caso o usuário altere a chave Compra/Venda via toggle na tela
    const handleTypeSwitch = (selectedType) => {
        setType(selectedType);
        const activeDetails = selectedType === 'sale' ? bird?.sale_details : bird?.purchase_details;
        setFormData({
            price: activeDetails?.price || '',
            date: activeDetails?.date ? new Date(activeDetails.date).toISOString().split('T')[0] : '',
            notes: activeDetails?.notes || ''
        });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrorMessage('');

        try {
            const token = JSON.parse(localStorage.getItem('token'));
            const payload = {
                type,
                ...formData
            };

            const response = await api.put(`/transaction/register/${id}`, payload, {
                headers: { Authorization: `Bearer ${token}` }
            });

            alert(response.data.message || 'Transação salva com sucesso!');
            navigate('/transaction');
        } catch (error) {
            setErrorMessage(error.response?.data?.message || 'Erro ao registrar transação.');
        }
    };

    if (loading) {
        return <p className={styles.loading}>Carregando detalhes...</p>;
    }

    if (!bird) {
        return (
            <div className={styles.container}>
                <p>Pássaro não encontrado.</p>
                <button className={styles.back_button} onClick={() => navigate('/transaction')}>
                    ← Voltar
                </button>
            </div>
        );
    }

    return (
        <div className={styles.container}>
            <div className={styles.profile_top_nav}>
                <button className={styles.back_button} onClick={() => navigate('/transaction')}>
                    ← Voltar para Transações
                </button>
            </div>

            <div className={styles.detail_header}>
                <div>
                    <h2>{bird.name}</h2>
                    <p className={styles.detail_subtitle}>
                        Anilha: {bird.bird_band} • Raça: {bird.race} • Cor: {bird.color}
                    </p>
                </div>
            </div>

            {/* Alternador de Tipo (Compra / Venda) */}
            <div className={styles.tab_switch}>
                <button 
                    className={`${styles.tab_btn} ${type === 'purchase' ? styles.tab_active_buy : ''}`}
                    onClick={() => handleTypeSwitch('purchase')}
                >
                    🛒 Registrar Compra
                </button>
                <button 
                    className={`${styles.tab_btn} ${type === 'sale' ? styles.tab_active_sell : ''}`}
                    onClick={() => handleTypeSwitch('sale')}
                >
                    💵 Registrar Venda
                </button>
            </div>

            <div className={styles.form_section}>
                <h3>{type === 'sale' ? 'Dados da Venda' : 'Dados da Compra'}</h3>
                {errorMessage && <p className={styles.error_msg}>{errorMessage}</p>}

                <form onSubmit={handleSubmit} className={styles.form}>
                    <label>Valor (R$) *</label>
                    <input 
                        type="number" 
                        step="0.01" 
                        name="price" 
                        placeholder="0.00"
                        value={formData.price} 
                        onChange={handleChange} 
                        required 
                    />

                    <label>Data *</label>
                    <input 
                        type="date" 
                        name="date" 
                        value={formData.date} 
                        onChange={handleChange} 
                        required 
                    />

                    <label>Observações / Detalhes</label>
                    <textarea 
                        name="notes" 
                        rows="4" 
                        placeholder="Ex: Comprador/Vendedor, forma de pagamento, etc."
                        value={formData.notes} 
                        onChange={handleChange} 
                    />

                    <div className={styles.form_actions}>
                        <button type="button" onClick={() => navigate('/transaction')} className={styles.btn_cancel}>
                            Cancelar
                        </button>
                        <button type="submit" className={type === 'sale' ? styles.btn_submit_sell : styles.btn_submit_buy}>
                            Salvar {type === 'sale' ? 'Venda' : 'Compra'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default TransactionProfile;